import { TimePicker } from '../../../DateTime'
import { Control } from '../Control'

import * as styles from './ControlTime.module.css'

function ControlTime({ value, onChange, ...controlProps }) {
  function handleChange(nextValue) {
    onChange(value, { value: nextValue })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <TimePicker
        borderless
        disabled={value.omitted}
        value={value.value ?? null}
        wrapperClassName={styles.inputWrap}
        onChange={handleChange}
      />
    </Control>
  )
}

export default ControlTime
